import { addClusteredPins, removeClusteredPins } from './clustered_pins';
import { addPreviewLines } from './preview_lines';
import { createAlgoliaTrailsObject, getSearchIndex } from '../../search';
import { addResultsHeatmapOverlay, heatmapOverlayId } from './heatmap';
import { GREEN } from '../../constants/PinColor';

const nearbyLayerId = 'nearbyTrails';

const addNearbyTrails = (map, trailId, renderHoverCard, enabledOverlays) => {
  return getSearchIndex()
    .performSearch(createAlgoliaTrailsObject(map))
    .then(content => {
      let results = content.hits;
      if (trailId) {
        results = results.filter(trail => trail.ID !== trailId);
      }
      addPreviewLines(map);
      addClusteredPins(map, nearbyLayerId, results, GREEN, renderHoverCard);
      if (enabledOverlays.includes(heatmapOverlayId(nearbyLayerId))) {
        addResultsHeatmapOverlay(map, nearbyLayerId, results, enabledOverlays, renderHoverCard);
      }
    });
};

const removeNearbyTrails = map => {
  removeClusteredPins(map, nearbyLayerId);
};

export { addNearbyTrails, removeNearbyTrails };
